import React from 'react';
import ReactDOM from 'react-dom/client';
import Router from './Router';
import { BrowserRouter } from "react-router-dom";
import "./languageConfig";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<BrowserRouter><Router /></BrowserRouter>);
